import { StoreState } from '@/core/models/store.interface';
import { ModuleKey, Role, RoleKey, checkRoleKey } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';
import { Permissions } from './permissions.interface';

export interface PermissionState {
   permissions?: Permissions;
   roles: Array<Role>;
}

const PermissionStore: Module<PermissionState, StoreState> = {
   namespaced: true,
   state: {
      roles: [],
   },
   getters: {
      permissions(state: PermissionState) {
         return state.permissions;
      },
      roles(state: PermissionState) {
         return state.roles;
      },
      isPlatformAdmin(state: PermissionState) {
         return checkRoleKey(RoleKey.PlatformAdmin, ModuleKey.NxtPay, state.roles);
      },
      isTenantAdmin(state: PermissionState) {
         return checkRoleKey(RoleKey.TenantAdmin, ModuleKey.NxtPay, state.roles);
      },
      isContractAdmin(state: PermissionState) {
         return checkRoleKey(RoleKey.ContractEditor, ModuleKey.NxtPay, state.roles);
      },
      isPerformanceAdmin(state: PermissionState) {
         return checkRoleKey(RoleKey.PerformanceAdmin, ModuleKey.NxtPay, state.roles);
      },
      isCustomerAdmin(state: PermissionState) {
         return checkRoleKey(RoleKey.CustomerAdmin, ModuleKey.NxtPay, state.roles);
      },
      isFictionalContractEditor(state: PermissionState) {
         return checkRoleKey(RoleKey.FictionalContractEditor, ModuleKey.NxtPay, state.roles);
      },
      isEtmTestingUser(state: PermissionState) {
         return checkRoleKey(RoleKey.EtmTesting, ModuleKey.NxtPay, state.roles);
      },
   },
   mutations: {
      SET_PERMISSIONS(state: PermissionState, permissions: Permissions) {
         state.permissions = permissions;
      },
      SET_ROLES(state: PermissionState, roles: Array<Role>) {
         state.roles = roles;
      },
   },
   actions: {},
};

export default PermissionStore;
